module.exports = __webpack_public_path__ + "assets/vw_academy.ab41b68d.svg";